import "../../css/Search.css";

const Search = ({ value, onChange, placeholder, children }) =>
  <form onSubmit={(event) =>  event.preventDefault()}>
    {children} <input
      type="text"
      value={value} 
      onChange={onChange}
      placeholder={placeholder}
    />
  </form>

export default Search;